<template>
  <div class="liff-staff-list">
    <div v-if="fetching" class="wizard-mode-layout__loading-overlay">
      <div class="wizard-mode-layout__loading-spinner"></div>
      <div class="wizard-mode-layout__loading-text">載入中...</div>
    </div>
    <div v-if="staffList.length == 0 && !fetching">
      此分店無可選用員工，請回上一頁重新選擇
    </div>
    <h4 class="text-center my-2" v-if="selectedBranch">{{ selectedBranch.name }}</h4>
    <h4 class="text-center my-2" v-if="selectedServicesForDisplay">{{ selectedServicesForDisplay }}</h4>
    <div class="liff-staff-list__content need-bottom" >
        <label
          v-for="staff in staffList"
          :key="staff.id"
          :for="staff.id"
          class="liff-staff-list__content-item"
          :class="{ 'active': chosenStaff.id === staff.id }"
        >
          <input type="radio" :id="staff.id" class="liff-staff-list__checkbox" :value="staff" v-model="chosenStaff">
          <img class="liff-staff-list__content-item-img" :src="staff.img || require('./images/staff.png')" alt="" >
          <div class="liff-staff-list__content-item-info">
            <div class="s-flex s-flex-col s-gap-2">
              <div>{{ staff.name }}</div>
              <div class="s-text-gray s-text-sm">{{ staff.position }}</div>
              <div v-if="staff.description" class="s-mt-3 s-mb-3 s-border-b s-border-gray-light"></div>
              <div v-if="staff.description" class="s-text-gray s-text-xs">{{ staff.description }}</div>
            </div>
          </div>
          <BIconCheckCircleFill v-if="chosenStaff.id === staff.id" :height="20" class="s-text-primary liff-staff-list__content-item-check" />
        </label>
    </div>

    <div class="wizard-mode-layout__footer-navigation">
      <div class="s-flex s-justify-between s-items-center s-mb-3" v-if="staffList.length != 0">
        <div class="s-font-medium">已選：<span class="s-text-primary">{{ chosenStaff.name }}</span></div>
        <div class="s-text-primary cursor-pointer s-font-medium s-flex-shrink-0" @click="chosenStaff = {}">重選</div>
      </div>
      <div class="wizard-mode-layout__footer-button-wrapper">
        <button
          class="s-btn s-liff-theme-btn-outline s-btn-sm"
          type="button"
          @click="handleNegativeButtonClicked"
          v-if="hasPreviousStep()"
        >
          上一步
        </button>
        <button
          v-if="staffList.length != 0"
          class="s-btn s-liff-theme-btn s-btn-sm"
          type="button"
          :disabled="!chosenStaff.id || staffList.length == 0"
          @click="handlePositiveButtonClicked"
        >
          {{ textForProceedButton() }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { BIconCheckCircleFill } from 'bootstrap-vue';
  import { mapActions, mapGetters, mapState } from 'vuex'
  import BookingPreset from '@/models/BookingPreset.model'
  import BookingBusinessLogic from '@/utils/booking/BookingBusinessLogic'

  const bookingBusinessLogic = new BookingBusinessLogic()

  export default {
    components: {
      BIconCheckCircleFill,
    },
    inject: ['back', 'proceed', 'hasPreviousStep', 'textForProceedButton'],
    data() {
      return {
        chosenStaff: {},
        fetching: false,
      }
    },
    computed: {
      ...mapGetters('liffBookingWizard', ['selectedServices']),
      ...mapState('liffBookingWizard', ['bookingPreset', 'availableStaffs', 'selectedBranch', 'selectedServiceIds']),
      branchId() {
        return this.$route.query.branch_id
      },
      staffId() {
        return this.$route.query.staff_id
      },
      dataModel() {
        return new BookingPreset(this.bookingPreset)
      },
      staffList() {
        return this.availableStaffs.map((staff) => ({
          id: staff.id,
          name: staff.name,
          position: staff.service_unit,
          img: staff.avatar_url,
          description: staff.description
        }))
      },
      selectedServicesForDisplay() {
        if (this.dataModel.wizardFieldOrder.service < this.dataModel.wizardFieldOrder.staff) {
          return this.selectedServices.map((service) => service.title).join('、')
        } else {
          return null
        }
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      ...mapActions('liffBookingWizard', ['fetchBookingPreset', 'fetchAvailableStaffs', 'selectStaff']),
      async init() {
        this.fetching = true
        await this.fetchBookingPreset({ bookingPresetId: this.$route.params.bookingPresetId, branchId: this.branchId })
        bookingBusinessLogic.setBookingPresetDataModel(this.dataModel)
        await this.fetchStaffsByServiceIds()
        if (this.staffId) {
          this.chosenStaff = this.staffList.find((s) => s.id == this.staffId) || {}
        }
        this.fetching = false
      },
      async fetchStaffsByServiceIds() {
        if (bookingBusinessLogic.staffsAreBoundToServices()) {
          await this.fetchAvailableStaffs({
            serviceIds: this.selectedServiceIds.length > 0 ? this.selectedServiceIds : null,
            branchId: this.branchId,
            bookingPresetId: this.$route.params.bookingPresetId,
          })
        } else {
          await this.fetchAvailableStaffs({
            serviceIds: null,
            branchId: this.branchId,
            bookingPresetId: this.$route.params.bookingPresetId,
          })
        }
      },
      handleNegativeButtonClicked() {
        this.selectStaff({
          id: this.chosenStaff.id,
          name: this.chosenStaff.name,
          img: this.chosenStaff.img
        })
        this.back()
      },
      handlePositiveButtonClicked() {
        this.selectStaff({
          id: this.chosenStaff.id,
          name: this.chosenStaff.name,
          img: this.chosenStaff.img
        })
        this.proceed()
      },
    }
  }
</script>

<style lang="scss" scoped>
.liff-staff-list {
  &__checkbox {
    display: none;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px 16px 16px;
    &.need-bottom {
      margin-bottom: 150px;
    }

    &-item {
      display: flex;
      align-items: center;
      border: 1px solid #E5E5EA;
      border-radius: 10px;
      padding: 12px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
      color: #2C2C2E;
      font-size: 18px;
      font-weight: 500;
      gap: 12px;
      cursor: pointer;
      position: relative;
      &:hover {
        background-color: #F5F5F5;
      }
      &.active {
        padding: 11px;
        border: 2px solid var(--s-primary);
      }
      &-img {
        width: 80px;
        height: 80px;
        border-radius: 50px;
        flex-shrink: 0;
      }
      &-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 12px;
      }
      &-check {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 32px;
        height: 32px;
        padding: 4px;
      }
    }
  }
}
</style>
